<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div class="row">
            <div class="col-lg-12">
              <h3 class="text-orange">Gestión de marketing</h3>
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <router-link to="/impresos">
                <div class="card" style="background-color: #000">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-auto">
                        <div class="stat stat-white text-orange">
                          <i class='align-middle bx bx-images bx-sm'></i>
                        </div>
                      </div>
                      <div class="col mt-0">
                        <h4 class="text-white mt-2">Piezas</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-lg-4">
              <router-link to="#">
                <div class="card" style="background-color: #000">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-auto">
                        <div class="stat stat-white text-orange">
                          <i class='align-middle bx bx-network-chart bx-sm'></i>
                        </div>
                      </div>
                      <div class="col mt-0">
                        <h4 class="text-white mt-2">Redes</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-lg-12">
              <div v-if="aliados.length != 0">
                <div class="card">
                  <div class="card-header"></div>
                  <div class="card-body">
                    <div class="mt-2 mb-2">
                      <div class="form-group">
                        <label>Buscar</label>
                        <v-select
                          v-model="aliado"
                          @search="get_aliados_search"
                          @input="get_aliados"
                          label="nombre_aliado"
                          :options="aliados_search"
                        ></v-select>
                      </div>
                    </div>
                    <div v-if="vista == 2" class="table-responsive">
                      <table
                        class="table table-bordered table-condensed table-hover my_table_1"
                      >
                        <thead>
                          <tr>
                            <th style="width: 2%">#</th>
                            <th style="width: 20%">Nombre</th>
                            <th style="width: 8%" class="text-center">
                              Ficha
                            </th>
                            <th style="width: 8%" class="text-center">
                              Logo
                            </th>
                            <th style="width: 8%" class="text-center">
                              Pieza revista
                            </th>
                            <th style="width: 8%" class="text-center">
                              Pieza redes sociales
                            </th>
                            <th style="width: 8%" class="text-center">
                              Pieza App
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(aliado, index_aliado) in aliados"
                            v-bind:key="index_aliado"
                          >
                            <td>{{ aliado.num }}</td>
                            <td>
                              <router-link
                                v-bind:to="'/aliado/' + aliado.id_aliado"
                              >
                                <h5 class="text-orange fw-bold mb-0">
                                  {{ aliado.nombre_aliado }}
                                </h5>
                              </router-link>
                              <span class="fw-bold text-muted">
                                {{ aliado.categoria }} </span
                              ><br />
                              <span
                                v-if="aliado.sucursal != null"
                                class="fw-bold text-muted"
                              >
                                {{ aliado.sucursal.sucursal }}
                              </span>
                            </td>
                            <td class="text-center">
                              <router-link
                                v-bind:to="
                                  '/aliado/ficha/' + aliado.id_aliado
                                "
                                class="btn btn-success rounded-pill"
                                target="_blank"
                                ><i class="bx bxs-check-circle"></i>
                              </router-link>
                            </td>
                            <td class="text-center">
                              <a
                                v-if="aliado.anexos.logo != null"
                                v-bind:href="aliado.anexos.logo"
                                class="btn btn-success rounded-pill"
                                target="_blank"
                                ><i class="bx bxs-check-circle"></i>
                              </a>
                              <span v-else class="text-danger">
                                <router-link
                                  v-bind:to="
                                    '/cargar_anexo/' +
                                    aliado.id_aliado +
                                    '/' +
                                    4
                                  "
                                  style="color:#dc3545;"
                                >
                                  <i class='bx bx-upload bx-sm'></i>
                                </router-link>  
                              </span>
                            </td>
                            <td class="text-center">
                              <a
                                v-if="aliado.anexos.pieza_h != null"
                                v-bind:href="aliado.anexos.pieza_h"
                                class="btn btn-success rounded-pill"
                                target="_blank"
                                ><i class="bx bxs-check-circle"></i>
                              </a>
                              <span v-else class="text-danger">
                                <router-link
                                  v-bind:to="
                                    '/cargar_anexo/' +
                                    aliado.id_aliado +
                                    '/' +
                                    5
                                  "
                                  style="color:#dc3545;"
                                >
                                  <i class='bx bx-upload bx-sm'></i>
                                </router-link> 
                              </span>
                            </td>
                            <td class="text-center">
                              <a
                                v-if="aliado.anexos.pieza_v != null"
                                v-bind:href="aliado.anexos.pieza_v"
                                class="btn btn-success rounded-pill"
                                target="_blank"
                                ><i class="bx bxs-check-circle"></i>
                              </a>
                              <span v-else class="text-danger">
                                <router-link
                                  v-bind:to="
                                    '/cargar_anexo/' +
                                    aliado.id_aliado +
                                    '/' +
                                    6
                                  "
                                  style="color:#dc3545;"
                                >
                                  <i class='bx bx-upload bx-sm'></i>
                                </router-link> 
                              </span>
                            </td>
                            <td class="text-center">
                              <a
                                v-if="aliado.anexos.pieza_a != null"
                                v-bind:href="aliado.anexos.pieza_a"
                                class="btn btn-success rounded-pill"
                                target="_blank"
                                ><i class="bx bxs-check-circle"></i>
                              </a>
                              <span v-else class="text-danger">
                                <router-link
                                  v-bind:to="
                                    '/cargar_anexo/' +
                                    aliado.id_aliado +
                                    '/' +
                                    9
                                  "
                                  style="color:#dc3545;"
                                >
                                  <i class='bx bx-upload bx-sm'></i>
                                </router-link> 
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="col-lg-12">
            <div
              class="mt-4 mb-4"
              aria-label="Page navigation example"
              v-html="paginate"
            ></div>
          </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Marketing",
  metaInfo: {
    title: "Marketing - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      loading_aliados: true,
      loading_solicitudes: true,
      sucursal: null,
      page: 1,
      aliados: [],
      paginate: null,
      vista: 2,
      mostrar_filtros: false,
      aliados_search: [],
      aliado: null,
      solicitudes_pendientes: 0,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    if (this.session.usuario.perfil != 0 && this.session.usuario.perfil != 2) {
      this.$router.push("/");
    }
    this.page = this.$route.params.page;
    var sucursal = localStorage.getItem("sucursal");
    if (sucursal != undefined) {
      this.sucursal = JSON.parse(sucursal);
    }

    this.get_aliados();
    this.get_sucursales();
    var mostrar_filtros = localStorage.getItem("mostrar_filtros");
    if (mostrar_filtros != undefined) {
      if (mostrar_filtros == "true") {
        this.mostrar_filtros = true;
      } else {
        this.mostrar_filtros = false;
      }
    }
    var vista = localStorage.getItem("vista");
    if (vista != undefined) {
      this.vista = vista;
    }
    this.get_sucursales();
    this.get_solicitudes();
  },
  methods: {
    get_aliados: function () {
      this.loading_aliados = true;
      var id_sucursal = null;
      if (this.sucursal != null) {
        id_sucursal = this.sucursal.id_sucursal;
        localStorage.setItem("sucursal", JSON.stringify(this.sucursal));
      }
      var id_aliado = null;
      if (this.aliado != null) {
        id_aliado = this.aliado.id_aliado;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          page: this.page,
          id_sucursal: id_sucursal,

          zona: this.zona,
          categoria: this.categoria,
          id_aliado: id_aliado,
        },
      };
      axios
        .get(this.$base_url + "aliados/aliados_marketing", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliados = response.data.data.aliados;
          this.total_aliados = response.data.data.total_aliados;
          this.get_paginate(response.data.data.total_pages);
          this.loading = false;
          this.loading_aliados = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_solicitudes: function () {
      this.loading_solicitudes = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          estado: 0,
        },
      };
      axios
        .get(this.$base_url + "aliados/solicitudes_piezas", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.solicitudes_pendientes = response.data.data.pendientes;
          this.loading_solicitudes = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_sucursales: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/sucursales", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.sucursales = response.data.data.sucursales;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_paginate: function (tpages) {
      var page = this.page;

      if (page === undefined || page <= 0) {
        this.page = 1;
        page = this.page;
      }

      var adjacents = 4;

      var paginate = null;

      paginate = '<ul class="pagination justify-content-center text-center">';
      // previous label
      if (page == 1) {
        paginate +=
          "<li class='paginate_button page-item previous disabled'><a class='page-link disabled'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else if (page == 2) {
        paginate +=
          "<li class='paginate_button page-item  previous'><a href='#/marketing/1' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else {
        var page_ant = parseFloat(page) - 1;
        paginate +=
          "<li class='paginate_button page-item'><a href='#/marketing/" +
          page_ant +
          "' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      }
      // first label
      if (page > parseFloat(adjacents) + 1) {
        paginate +=
          "<li class='paginate_button page-item'><a class='page-link' href='#/marketing/1'>1</a></li>";
      }
      // interval
      if (page > parseFloat(adjacents) + 2) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // pages
      var pmin =
        page > adjacents ? parseFloat(page) - parseFloat(adjacents) : 1;
      var pmax =
        page < parseFloat(tpages) - parseFloat(adjacents)
          ? parseFloat(page) + parseFloat(adjacents)
          : tpages;

      for (var i = pmin; i <= pmax; i++) {
        if (i == page) {
          paginate +=
            "<li class='paginate_button page-item active'><a href='#/marketing/" +
            i +
            "' class='page-link'>" +
            i +
            "</a></li>";
        } else if (i == 1) {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/marketing/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        } else {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/marketing/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        }
      }
      // interval
      if (page < parseFloat(tpages) - parseFloat(adjacents) - 1) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // last
      if (page < parseFloat(tpages) - parseFloat(adjacents)) {
        paginate +=
          "<li class='paginate_button page-item'><a  href='#/marketing/" +
          tpages +
          "' class='page-link' href='javascript:void(0);'>" +
          tpages +
          "</a></li>";
      }
      // next
      if (page < tpages) {
        var page_next = parseFloat(page) + 1;
        paginate +=
          "<li class='paginate_button page-item next'><a  href='#/marketing/" +
          page_next +
          "' class='page-link' href='javascript:void(0);'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      } else {
        paginate +=
          "<li class='paginate_button page-item next disabled'><a class='page-link disabled'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      }
      paginate += "</ul>";
      this.paginate = paginate;
    },
    get_aliados_search: function (search) {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          search: search,
        },
      };
      axios
        .get(this.$base_url + "aliados/aliados", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliados_search = response.data.data.aliados;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    toggle_filtros: function () {
      this.mostrar_filtros = !this.mostrar_filtros;
      localStorage.setItem("mostrar_filtros", this.mostrar_filtros);
    },
    toggle_vista: function (vista) {
      this.vista = vista;
      localStorage.setItem("vista", this.vista);
    },
  },
  mounted: function () {
    this.loading = false;
  },
  watch: {
    $route() {
      this.page = this.$route.params.page;
      this.get_aliados();
    },
  },
};
</script>